<template>
  <el-dialog
    width="20%"
    :visible.sync="this.$store.state.Dialog_Change_Phone"
    :modal-append-to-body="false"
    :show-close="false"
    :before-close="handleClose"
    class="dialog"
    destroy-on-close
    @open="opendialog"
  >
    <div class="dialog_body">
      <CardHeader :name="headerName" @closeDrawer="handleClose"></CardHeader>

      <div class="center_card">
        <div class="LoginPhone">
          <div class="input">
            <div class="input_name">手机号</div>
            <el-input
              v-model="phonenumber"
              placeholder="请填写新手机号"
            ></el-input>
          </div>

          <div class="input">
            <div class="input_name"><span class="Required">*</span>验证码</div>
            <el-input
              v-model="pohoneCode"
              ref="code"
              placeholder="请输入验证码"
              class="name_getcode"
            >
              <template slot="append">
                <div class="input_name_in" @click="getCode" v-if="!count">
                  获取验证码
                </div>
                <div class="input_name_in" v-if="count">
                  {{ count }}秒后重发
                </div>
              </template>
            </el-input>
          </div>
          <div class="out_msg">*更换手机号后，下次登录可使用新手机号</div>
          <div class="login_button">
            <div
              class="button"
              @click="onSubmit()"
              v-if="pohoneCode && phonenumber"
            >
              验证
            </div>
            <div class="button_no" v-if="!pohoneCode || !phonenumber">验证</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { phoneverifyCode, authcheckingphonecode } from "../../../api/api";
import CardHeader from "../../../components/cardHeader/index.vue";
import { checkPhone } from '@/utils/tools';
export default {
  props: [],
  components: { CardHeader },
  name: "dialogTree",
  data() {
    return {
      headerName: "更换手机号码",
      phonenumber: "", //手机号
      pohoneCode: "", //验证码
      timer: null,
      count: null,
    };
  },

  methods: {
    /**
     * 模态框打开
     * */

    opendialog() {},

    /**
     * 点击下一步
     * */

    onSubmit() {
      let params = {
        phone: this.phonenumber,
        code: this.pohoneCode,
      };
      authcheckingphonecode(params).then((res) => {
        if (res.code == 200 && res.data) {
          this.$emit("newphone", this.phonenumber);
          this.handleClose();
        }
      });
    },

    /**
     * 点击获取验证码
     * */

    getCode() {
      if (checkPhone(this.phonenumber)) {
        let params = {
          phone: this.phonenumber,
          type: "Binding",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
            this.$refs.code.focus();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },

    /**
     * 60秒倒计时，验证码请求成功后开始
     * */

    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    /**
     * 关闭模态框
     * */

    handleClose() {
      this.$store.commit("SET_Dialog_Change_Phone", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .dialog_body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .center_card {
      z-index: 10;
      height: 15rem;
      padding: 1rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      .LoginPhone {
        width: 100%;

        .out_msg {
          font-size: 12px;
          color: #b7282d;
        }

        .title {
          font-weight: 400;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3.75rem;
        }
        .input {
          position: relative;
          padding: 1.25rem 0 0.625rem 0;
          .input_name {
            z-index: 5;
            position: absolute;
            color: #999999;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.375rem;
            background: #fff;
            left: 5%;
            top: 0.375rem;
          }

          .input_name_in {
            width: 100%;
            height: 100%;
            user-select: none;
            cursor: pointer;
          }
        }

        .erro {
          user-select: none;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          color: #f84638;
        }

        .login_button {
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 1rem;

          .button {
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #b7282d;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .button_no {
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #ccc;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .suss_msg {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 1.625rem;
          line-height: 2.25rem;
          color: #333333;
        }
        .avatar-uploader {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .avatar-uploader .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader-icon {
          font-size: 1.75rem;
          color: #8c939d;
          width: 5.5rem;
          height: 5.5rem;
          line-height: 5.5rem;
          text-align: center;
          border: 0.0625rem dashed #ccc;
          border-radius: 0.375rem;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          display: block;
        }
      }
    }
    .footer {
      margin-top: 1.25rem;
    }
  }
}
</style>